import type { OrderSiteAvailabilityRequest } from '@moko/utils';
import { internalFetch } from '../utils/fetchHelper';
import { IPagedCollection } from '@moko/utils';

export interface IOrder {
  tenantId?: number;
  orderedFormDefinitionId?: number;
  orderedEntityMetadataId?: number;
  id: number;
  code: string;
  description: string;
  specialInstruction?: string | null;
  otherInfo: any;
  status?: string;
  statusId?: number;
  entityType?: string;
  metadataName?: string;
  orderedEntityType?: string;
  relatedAssetIds?: number[];
  relatedAssetCodeAndNames?: string[];
  workTypeId?: number | null;
}

export interface IUpdateOrderRequest {
  orderedFormDefinitionId?: number;
  orderedEntityMetadataId?: number;
  code?: string;
  description?: string;
  specialInstruction?: string | null;
  otherInfo?: Record<string, unknown>;
  status?: string;
  statusId?: number;
  orderedEntityType?: string;
  orderedMetadataName?: string;
  relatedAssetIds?: number[];
}

export interface ICreateOrderRequest {
  selectedEntityMetadataId?: number;
  orderedFormDefinitionId?: number;
  orderedEntityMetadataId?: number;
  siteAvailabilityWindows?: OrderSiteAvailabilityRequest[];
  code: string;
  description: string;
  specialInstruction?: string | null;
  otherInfo: Record<string, unknown>;
  status?: string;
  statusId?: number;
  metadataName?: string;
  orderedMetadataName?: string;
  orderedEntityType?: string;
  relatedAssetIds?: number[];
  workTypeId?: number | null;
}

export interface ICreateOrderResponse {
  orderId: number;
}

export const getOrders = async (
  abortController: AbortController,
  pageSize: number,
  pageNo: number,
  orderBy?: string,
  search?: string,
  filters?: string
): Promise<IPagedCollection<IOrder>> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/orders?pageSize=${pageSize}&pageNo=${pageNo}${
      orderBy ? `&orderBy=${orderBy}` : ''
    }${search ? `&search=${search}` : ''}${
      filters ? `&filters=${encodeURIComponent(filters)}` : ''
    }&code=${import.meta.env.VITE_BACKEND_API_KEY}`,
    'GET',
    abortController
  );
};

export const getOrder = async (
  abortController: AbortController,
  orderId?: number
): Promise<IOrder> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/order?orderId=${orderId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const editOrder = async (
  abortController: AbortController,
  orderId: number,
  order: IUpdateOrderRequest
): Promise<number> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/order?orderId=${orderId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'PUT',
    abortController,
    JSON.stringify(order)
  );
};

export const createOrder = async (
  abortController: AbortController,
  data: ICreateOrderRequest
): Promise<ICreateOrderResponse> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/order`,
    'POST',
    abortController,
    JSON.stringify(data)
  );
};

export interface ICreateOrderedResponse {
  entityType: string;
  entityId: number;
}

export const createOrderedEntity = async (
  abortController: AbortController,
  orderId: number
): Promise<ICreateOrderedResponse> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/orderedEntity?orderId=${orderId}`,
    'POST',
    abortController
  );
};
